import { Injectable } from '@angular/core';
import { Question } from '../models/question';

@Injectable({
    providedIn: 'root'
})
export class HelperService {

    findTagsFromForm(form: any, currentQuestion: Question): string[] {
        let tags = [];

        if (form.body) {
            form.body.map(tab => tab.fields.map((q: Question) => {
                if (q.tag !== currentQuestion.tag)  {
                    tags.push(q.tag.toLowerCase());
                }

                tags = tags.concat(multipleOutputs(q, currentQuestion));
            }));
        }
        return tags;

        function multipleOutputs(q: Question, currentQuestion: Question): string[] {
            const tags = [];
            const outputs = q.templateOptions.multipleOutputs;
            const currentOutputs = currentQuestion.templateOptions.multipleOutputs;

            if (!outputs) // if a is negative,undefined,null,empty
            {
              return tags;
            }

            if (outputs.length) {
                outputs.map(o => {
                    if (currentOutputs.length) {
                        currentOutputs.map(co => {
                            if (co.tag !== o.tag) {
                                tags.push(o.tag.toLowerCase());
                            }
                        });
                    } else {
                        tags.push(o.tag.toLowerCase());
                    }
                })
            }

            return tags;
        }
    }
}
